import { Variant } from '@kizi/core-components';
import anchors from './anchors';
import p from './paragraphs';
import icon from './svgs';

const borderBottomDashed = {
  pb: [null, null, '3px'],
  borderBottom: [null, null, '1px dashed'],
  borderBottomColor: [null, null, 'lightMain1'],
};

const borderBottomMobile = {
  pb: '3px',
  borderBottom: '1px dashed',
  borderBottomColor: 'lightMain1',
};

const borderBottomClassic = {
  borderBottom: '1px solid',
  borderColor: 'second.1',
};

const avatar: Variant = {
  '& > img': {
    borderRadius: 3,
    height: [32, null, 100],
    width: [32, null, 100],
    minWidth: [32, null, 100],
  },
  '& >div': {
    mt: 2,
    '& p:nth-of-type(2n)': {
      textAlign: 'center',
      mt: 1,
    },
  },
};

const footnotesContainer: Variant = {
  '& p': {
    ...p.footnoteRegular,
    pb: 1,
  },
};
const paragraphsContainer: Variant = {
  '& p': {
    ...p.bodyRegular,
    pb: 1,
  },
};

const primaryContainerWithoutPadding: Variant = {
  bg: 'white',
  boxShadow: 'default',
  borderRadius: 2,
  color: 'main.2',
};

const primaryContainer: Variant = {
  ...primaryContainerWithoutPadding,
  px: [3, null, 5],
  py: [3, null, 6],
  mb: 6,
};

const primaryContainerPopover: Variant = {
  bg: 'white',
  boxShadow: [null, 'default'],
  borderRadius: [null, 2],
  height: 'fit-content',
  p: 4,
};

const price: Variant = {
  display: 'inline-flex',
  flexDirection: 'column',
  span: {
    fontWeight: 1,
    lineHeight: 2,
    fontFamily: 'heading',
  },
};

const priceMedium: Variant = {
  ...price,
  '> div > div > span': {
    ':first-of-type': {
      fontSize: 5,
    },
    ':last-of-type': {
      fontSize: 1,
    },
  },
  '.discount': {
    borderRadius: 20,
    px: 1,
    py: '2px',
  },
  label: {
    mt: [1, null, 0],
    ...borderBottomDashed,
  },
};

const priceMediumWithoutBorder: Variant = {
  ...price,
  pt: 2,
  pb: 2,
  '> div > div > span': {
    ':first-of-type': {
      fontSize: 5,
    },
    ':last-of-type': {
      fontSize: 1,
    },
  },
  '.discount': {
    borderRadius: 20,
    px: 1,
    py: '2px',
  },
  label: {
    mt: [1, null, 0],
    pb: '3px',
  },
};

const priceBig: Variant = {
  ...price,
  '> div': {
    color: 'main.2',
    display: 'flex',
    flexDirection: ['row-reverse', null, 'column'],
    '> div': {
      textAlign: 'right',
      '> span': {
        ':first-of-type': {
          fontSize: [3, null, 6],
        },
        ':last-of-type': {
          fontSize: [0, null, 3],
        },
      },
    },
  },
  '.discount': {
    borderRadius: 2,
    ml: [null, null, 'auto'],
    mr: [1, null, 0],
    my: 'auto',
    p: 1,
  },
  label: {
    mt: 1,
    textAlign: 'right',
  },
};

const priceBigWithBorder: Variant = {
  ...priceBig,
  '> div': {
    color: 'main.2',
    display: 'flex',
    flexDirection: ['row-reverse', null, 'column'],
    '> div': {
      width: 'min-content',
      maxHeight: 45,
      alignSelf: 'flex-end',
      ...borderBottomDashed,
      pb: 0,
      '> span': {
        ':first-of-type': {
          fontSize: [3, null, 6],
        },
        ':last-of-type': {
          fontSize: [0, null, 3],
        },
      },
    },
  },
  label: {
    mt: 3,
    textAlign: 'right',
  },
  cursor: 'pointer',
};

const priceCompare: Variant = {
  ...price,
  '> div': {
    color: 'main.2',
    display: 'flex',
    flexDirection: ['row-reverse', null, 'column'],
    '> div': {
      textAlign: 'right',
      '> span': {
        ':first-of-type': {
          fontSize: [3, null, 5],
        },
        ':last-of-type': {
          fontSize: [0, null, 1],
        },
      },
    },
  },
  '.discount': {
    borderRadius: 2,
    ml: [null, null, 'auto'],
    mr: [1, null, 0],
    my: 'auto',
    p: 1,
  },
  label: {
    textAlign: 'right',
    fontSize: [0, null, 1],
  },
};

const ratingReviews: Variant = {
  '> div': {
    display: 'flex',
    flexDirection: 'row',
    mb: 1,
    '> div': {
      my: 'auto',
    },
  },
};

const formGroup: Variant = {
  display: 'flex',
  flexDirection: 'column',
  color: 'text',
  'input, select': {
    color: 'text',
    boxSizing: 'border-box',
    fontWeight: 0,
  },
  input: {
    lineHeight: 2,
  },
  'input::placeholder, select::placeholder': {
    color: 'placeholder',
    fontWeight: 0,
    fontSize: 3,
  },
  '> img': {
    objectFit: 'contain',
  },
};

const formGroupError: Variant = {
  ...formGroup,
  color: 'error',
};

const formGroupInline: Variant = {
  color: 'text',
  display: 'flex',
  alignItems: 'center',
  // '& > label': {
  //   fontSize: 2,
  //   fontWeight: 500,
  //   mr: 2,
  // },
};

const formGroupInlineReversed: Variant = {
  ...formGroupInline,
  flexDirection: 'row-reverse',
  justifyContent: 'flex-end',
  // '& > label': {
  //   fontSize: 3,
  //   fontWeight: 0,
  //   ml: 2,
  // },
};

const formGroupInlineReversedWithBorder: Variant = {
  ...formGroupInlineReversed,
  my: 4,
  pt: 4,
  borderTop: '1px solid',
  borderColor: 'second.1',
};

const sustainability: Variant = {
  bg: 'second.2',
  px: 3,
  py: 2,
  svg: {
    mr: 3,
  },
};

const prosCons: Variant = {
  '> div': {
    div: {
      fontSize: 2,
      lineHeight: 2,
      color: 'main.2',
    },
    svg: {
      mt: '2px',
    },
  },
};

const rowBorder: Variant = {
  borderBottom: ['1px solid', null, 'none'],
  borderBottomColor: 'second.1',
};

const rowPadding: Variant = {
  py: [3, null, 0],
};

const productLogoWrapper = {
  maxWidth: 80,
};

const productLeftCol = {
  width: 115,
};

const product: Variant = {
  ...primaryContainerWithoutPadding,
  '> div': {
    '.alwaysVisible > div': {
      '.buildButton': {
        ml: 'auto',
        mt: [2, null, 3],
      },
      ...rowPadding,
      '&:nth-of-type(1)': {
        ...rowBorder,
        pt: 0,
      },
      '&:nth-of-type(2)': {
        ...rowBorder,
        borderLeftStyle: [null, null, 'solid'],
        borderLeftWidth: '1px',
        borderLeftColor: 'second.1',
        borderRightStyle: [null, null, 'solid'],
        borderRightWidth: '1px',
        borderRightColor: 'second.1',
        justifyContent: [null, null, 'space-between'],
        py: [null, null, 4],
        px: [null, null, 3],
        width: [null, null, '100%'],
        '> div': {
          my: [null, null, 'auto'],
          '&:nth-of-type(1)': {
            mr: [null, null, 6],
          },
          '&:nth-of-type(2)': {
            '> div': {
              '> div': {
                my: [null, null, 'auto'],
              },
            },
          },
        },
      },
      '&:nth-of-type(3)': {
        borderBottom: 'none',
        pb: 0,
        pl: [null, null, 35],
        display: 'flex',
        alignItems: 'center',
        '> div': {
          color: 'main.1',
        },
      },
    },
  },
  '&:not(.open)': {
    '> div': {
      '.alwaysVisible > div': {
        '&:nth-of-type(3)': {
          pb: 0,
        },
      },
    },
  },
  '&.open': {
    pb: [null, null, 35],
    '> div.expandedPart': {
      '> div.desktop': {
        mt: 6,
        '> div.separator': {
          bg: 'second.1',
          height: '1px',
          width: '100%',
          mb: 6,
        },
        '> div:nth-of-type(2)': {
          '> div': {
            '&:last-of-type': {
              '> div > div': {
                width: '100%',
                '&:first-of-type:not(:last-of-type)': {
                  mr: 3,
                },
                '&:last-of-type:not(:first-of-type)': {
                  ml: 0,
                },
              },
            },
          },
        },
      },
      '> div.mobile': {
        '> div:first-of-type': {
          borderBottom: ['1px solid', null, 'none'],
          borderBottomColor: 'second.1',
          borderTop: ['1px solid', null, 'none'],
          borderTopColor: 'second.1',
          ...rowPadding,
        },
      },
    },
  },
};

const grayedContainer: Variant = {
  '> *:not(button:last-of-type)': {
    filter: 'grayscale(1)',
    opacity: 0.6,
  },
};

const grayedContainerMobile: Variant = {
  '> ul > li > div': {
    filter: 'grayscale(1)',
    opacity: 0.6,
  },
};

const unavailablePriceContainer: Variant = {
  mt: '4',
  textAlign: 'right',
  maxWidth: '120px',
};

const productTabSwitch: Variant = {
  'div.tab-section': {
    mt: [3, 0],
    '&:first-of-type > p': {
      mb: 3,
    },
    '&:last-of-type > p': {
      mb: 6,
    },
  },
};

const baseRadioTile: Variant = {
  bg: 'white',
  borderRadius: 2,
  color: 'text',
  boxShadow:
    '0px 0px 2px rgba(78, 90, 126, 0.08), 0px 4px 12px rgba(62, 72, 101, 0.14)',
};

const radioTileHorizontal: Variant = {
  ...baseRadioTile,
  p: '18px 18px',
};

const radioTileVertical: Variant = {
  ...baseRadioTile,
  p: '8px 8px',
};

const labelChecked = {
  'p': { color: '#FFFFFF !important' },
};

const primaryCard: Variant = {
  bg: 'white',
  borderRadius: 2,
  padding: [3, 6],
  color: 'text',
  boxShadow: 'default',
};

const secondaryCard: Variant = {
  ...primaryCard,
  bg: 'main.2',
  color: 'white',
};

const complementaryCard: Variant = {
  ...primaryCard,
  bg: 'second.2',
};

const membershipUsp: Variant = {
  ...primaryCard,
  boxShadow: 'unset',
  padding: [4],
  bg: 'second.2',
  ml: [0, 0, 6],
  h4: {
    color: 'main.2',
  },
  '> div > p': {
    color: 'main.2',
    fontSize: 3,
  },
};

const sections: Variant = {
  '> div': {
    py: [3, null, 4],
    '&:not(:last-of-type)': {
      borderBottom: '1px solid',
      borderColor: 'second.1',
    },
  },
};

const checkboxGroup: Variant = {
  '> div > label': {
    fontWeight: 1,
    fontSize: 2,
    mb: 0,
  },
  '> div': {
    mt: 3,
    '> div > label': {
      fontSize: 3,
      fontWeight: 0,
      mb: 0,
      ml: 2,
    },
  },
};

const contentTypeCheckbox: Variant = {
  '> div > label': {
    fontWeight: 1,
    fontSize: 2,
    mb: 0,
  },
  '> div:not(:first-child)': {
    mt: 3,
    '> div > label': {
      fontSize: 3,
      fontWeight: 0,
      mb: 0,
      ml: 2,
    },
  },
};

const select = {
  '> label': {
    fontSize: 2,
    fontWeight: 1,
  },
  '> div': {
    mt: 4,
  },
};

const filters = {
  '> div': {
    '&:not(:last-of-type)': {
      borderBottomColor: 'second.1',
      borderBottomStyle: 'solid',
      borderBottomWidth: '1px',
      pb: 4,
    },
    mt: 4,
    '> div > h4': {
      color: 'main.2',
      fontFamily: 'heading',
      fontSize: 4,
    },
  },
};

const bannerInfo: Variant = {
  bg: 'main.2',
  borderRadius: 2,
  p: [3, 4],
  '.banner-title': {
    ...p.bodyImportantLight,
    mb: 1,
  },
  ...p.bodyLight,
  '& > svg': {
    ...icon.regularLight,
    mb: [2, 0],
    mr: [0, 4],
  },
};

const bannerWarning: Variant = {
  ...bannerInfo,
  bg: 'warning',
  color: 'text',
  '.banner-title': {
    ...p.bodyImportant,
    mb: 1,
  },
  '& >svg': {
    ...icon.regular,
  },
};

const bannerSuggestion: Variant = {
  ...bannerWarning,
  bg: 'second.2',
};

const bannerDiscount: Variant = {
  ...bannerWarning,
  bg: 'supplementary.2',
};

const bannerDiscountMobile: Variant = {
  ...bannerDiscount,
  flexDirection: 'row !important',
  alignItems: 'center !important',
  '> svg': {
    position: 'relative',
    top: '15px',
    width: '40px',
    height: '40px',
    mr: 1,
  },
  '> div': {
    maxWidth: '255px',
  },
};

const startWidget: Variant = {
  ...primaryContainer,
  px: 6,
  py: 6,
  fontFamily: 'heading',
  '& > p': {
    fontSize: '16px',
    lineHeight: '24px',
    fontFamily: 'Segoe UI, sans-serif',
    mb: 30,
  },
  '& a': {
    textDecoration: 'underline',
    color: 'info',
  },
  width: [null, null, 410],
  '& > h3': {
    mt: 0,
    mb: 6,
  },
  '& button': {
    mt: 6,
    width: '100%',
  },
};

const startWidgetHorizontal: Variant = {
  ...startWidget,
  justifyContent: 'flex-start!important',
  boxSizing: 'border-box',
  width: '1072px',
  minHeight: [null, '272px', '272px'],
  maxHeight: [null, '372px', '372px'],
  maxWidth: ['355px', '780px', '1072px'],
  mb: null,
  '& p + div > div > div > div': {
    minWidth: ['88px', null, null],
    maxWidth: [null, '159px', '159px'],
  },
  '> div > div': {
    mb: 'auto',
    '> div': {
      mt: 0,
      pt: 0,
      mr: 3,
    },
  },
  '> div > div:first-of-type': {
    minWidth: [undefined, '400px'],
  },
  '> div > div:not(:first-of-type)': {
    mt: [6, 0],
  },
  '& button': {
    ml: [0, 3],
    mb: 'auto',
    mt: '30px',
    minWidth: '210px',
    width: ['100%', 'fit-content'],
    height: 'inherit',
    lineHeight: '23px',
  },
};

const startWidgetHorizontalPadded: Variant = {
  ...startWidgetHorizontal,
  justifyContent: 'flex-start!important',
  minHeight: [null, '372px', '372px'],
  width: '768px',
  maxWidth: ['355px', '768px', '768px'],
  '> div > div:last-child > div > div': {
    marginTop: '0',
    marginBottom: 3,
  },
  '> div > div:first-of-type': {
    minWidth: [undefined, '300px'],
  },
  '& button': {
    ml: [0, 3],
    mb: 'auto',
    mt: 0,
    minWidth: '210px',
    width: ['100%', 'fit-content'],
    height: 'inherit',
    lineHeight: '23px',
  },
  '> div > div:first-child > div > div:nth-child(2) > input': {
    maxWidth: '90px',
  },
  '> div > div:nth-child(3) > div > div': {
    minWidth: '220px',
  },
};

const modalContainer: Variant = {
  bg: 'white',
  borderRadius: 2,
  boxShadow: 'default',
  my: 7,
  width: ['100%', '80%', '60%'],
  maxWidth: 760,
  height: 'fit-content',
  maxHeight: [null, 'calc(100% - 160px)'],
  zIndex: '90',
};

const productModalTopPanel: Variant = {
  borderTopRightRadius: 2,
  borderTopLeftRadius: 2,
  bg: 'white',
  px: 6,
  pb: 3,
  justifyContent: 'space-between',
};

const productModalProductPrice: Variant = {
  ...priceBig,
};

const YPaddingMedium = {
  py: 6,
};

/** TAB VIEW **/
const lightTabViewTabsContainer: Variant = {
  pt: [3, 6],
  pb: [3, null, 3],
  ...borderBottomClassic,
  flexDirection: ['column', null, 'row'],
  '> div:nth-child(1n)': {
    marginBottom: [3, null],
  },
  '> div:nth-child(2n)': {
    display: ['none', null, 'block'],
  },
};

const lightTabViewTabsContainerForModal: Variant = {
  ...lightTabViewTabsContainer,
  pt: [0, null, 6],
  pb: [0, null, 3],
  overflow: 'auto',
  '> div:nth-child(1n)': {
    marginBottom: [3, null],
    whiteSpace: 'nowrap',
  },
  '> div:nth-child(2n)': {
    display: ['none', null, 'block'],
    minWidth: 10,
    width: 50,
    '> div': {
      width: '100%',
    },
  },
};

const lightTabViewTab: Variant = {
  cursor: 'pointer',
  color: 'disabled',
};

const lightTabViewTabSelected: Variant = {
  ...lightTabViewTab,
  color: 'text',
};

const tabViewTabsContainer: Variant = {
  display: 'flex',
  overflowX: ['scroll', null, 'visible'],
  mb: [3, 6],
};

const tabViewTabsContainerIndented: Variant = {
  ...tabViewTabsContainer,
  borderBottom: '1px solid',
  borderColor: 'second.1',
  px: 6,
  whiteSpace: 'nowrap',
};

const tabViewTab: Variant = {
  color: 'main.1',
  mr: 5,
  py: 2,
};

const tabViewTabSelected: Variant = {
  ...tabViewTab,
  borderBottom: '3px solid',
  borderColor: 'main.1',
  fontWeight: 1,
};

const tabViewContent: Variant = {};

const tabViewContentIndented: Variant = {
  px: 6,
  pb: 3,
};

const divider: Variant = {
  borderTop: '1px solid',
  borderColor: 'divider',
  marginBottom: 2,
};

const detailsListHeading: Variant = {
  pb: 3,
};

const unitInput = {
  ...p.bodyRegular,
  color: 'disabled',
};

const operational = {
  width: '7px',
  height: '7px',
  borderRadius: 3,
  mr: 2,
  '&.active': {
    backgroundColor: 'supplementary.2',
  },
  '&.offline': {
    backgroundColor: 'supplementary.5',
  },
};

const contactItem = {
  mb: [4, 6],
  alignItems: 'center',
  ':last-of-type': {
    mb: 0,
  },
};

const accordionContainer: Variant = {
  ul: {
    '&:not(:last-of-type)': {
      borderBottomColor: 'second.1',
      borderBottomStyle: 'solid',
      borderBottomWidth: '1px',
    },
  },
};

const modalAccordionContent = {
  ...p.bodyRegular,

  p: {
    ...p.bodyRegular,
    m: 0,
    pt: 6,
    'first-of-type': {
      pt: 0,
    },

    '> a': {
      ...anchors.anchorRegular,
    },
  },
  ul: {
    pb: 6,
    pl: 2,
    pt: 2,
    listStyle: 'inside',
    ':last-of-type': {
      pb: 0,
    },
  },
  ol: {
    pb: 6,
    'last-of-type': {
      pb: 0,
    },
  },
  table: {
    tableLayout: 'fixed',
    width: '100%',
    mt: 3,
  },
  'table, th, td': {
    borderCollapse: 'collapse',
    borderSpacing: 0,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'second.1',
    textAlign: 'center',
  },
};

const modalHeader = {
  p: {
    ...p.bodyRegular,
    '&:not(:last-of-type)': {
      pb: 6,
    },
  },
};

const uspParagraphContainer = {
  p: {
    ...p.footnoteLight,
  },
  '&:not(:last-of-type)': {
    mb: 4,
  },
};

const uspParagraphContainerTop = {
  p: {
    ...p.footnoteLight,
  },
  '&:not(:last-of-type)': {
    mb: 4,
  },
  alignItems: 'start',
};

const borderCard: Variant = {
  bg: 'white',
  borderColor: 'second.1',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderRadius: 2,
  padding: 3,
  color: 'text',
};

const personalDataFieldContainer = {
  '&:not(:first-of-type)': {
    mt: 3,
  },
  '> div': {
    m: 0,
  },
};

const personalDataTemplateContainer = {
  '&:not(:first-of-type)': {
    mt: 3,
  },
};

const truncatedReview = {
  fontSize: 2,
  lineHeight: 2,
};

const addressInSidenav = {
  '> div > div:nth-child(1)': {
    minWidth: '96px',
  },
};

const sidenav = {
  minWidth: '315px',
};

const prosConsItem = {
  ...borderBottomDashed,
};

const afterTheSwitchApply = {
  ...primaryCard,
  '> p:first-child': {
    fontSize: [2, 4],
  },
};

const promotionBar = {
  bg: 'second.2',
  borderTopLeftRadius: 2,
  borderTopRightRadius: 2,
  px: [3, null, 5],
  svg: {
    mr: 2,
  },
  '> div:not(:last-child)': {
    mb: [2, null, 0],
  },
};

const promotionBarItem = {
  py: 2,
  '> p': {
    ...borderBottomMobile,
  },
};
const applyFormFooterContainer = {
  mt: 6,
  ...p.captionRegular,
  color: 'second.0',
  'p:not(:first-child)': {
    mt: 2,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
};

const circleWrapper = {
  borderRadius: '50%',
  p: 3,
  fontSize: 0,
  display: 'inline-flex',
};

const productUsp: Variant = { color: 'main.2', cursor: 'pointer', fontSize: 2 };

const CheckoutTopNotification = {
  ...primaryCard,
  py: [4, null, null, 7],
  px: [3, null, null, 80],
  '> p:not(:last-child)': {
    marginBottom: 6,
  },
};

const termsListWrapper = {
  '> p': {
    color: 'main.1',
    svg: {
      marginLeft: 2,
    },
  },
};

const tooltipContainer = {
  ...primaryContainer,
  width: '200px',
};

const innerComparisonContainer = {
  display: 'flex',
  width: '100%',
};

const sustainabilityRegular: Variant = {
  svg: {
    mr: 2,
    width: '20px',
    height: '20px',
  },
  span: {
    ...p.footnoteRegular,
  },
};

const outerComparisonContainer: Variant = {
  borderBottom: '1px solid',
  borderColor: 'second.1',
};

const headRowContainer: Variant = {
  columnGap: '1.875rem',
  verticalAlign: 'top',
  overflowY: 'hidden',
  display: 'flex',
  '>div': {
    maxWidth: '275px',
    minWidth: '150px',
    paddingTop: 3,
    paddingBottom: 3,
    flex: 1,
    display: 'flex',
  },
  '> div: not(:first-child)': {
    background: 'white',
    boxShadow: 'default',
    padding: '15px 15px 1px 15px',
  },
};

const bodyRowContainer: Variant = {
  ...headRowContainer,
  paddingRight: 3,
  paddingBottom: 0,
  ':last-of-type': {
    'div: not(:first-child)': {
      '>div': {
        paddingBottom: 3,
        borderBottom: '1px solid',
        borderColor: 'second.1',
        alignItems: 'stretch',
        display: 'flex',
        width: '100%',
      },
    },
  },
};

const cellContainer: Variant = {
  display: 'flex',
  '>div': {
    width: '100%',
    paddingBottom: 3,
    borderBottom: '1px solid',
    borderColor: 'second.1',
  },
};

const accordionChild: Variant = {
  '>div': {
    paddingLeft: 4,
  },
};

const accordionHeader: Variant = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  cursor: 'pointer',
};

const uniqueRowField: Variant = {
  width: [null, null, '50%'],
};

const addressDisplay: Variant = {
  ...outerComparisonContainer,
  mb: 4,
  pb: 3,
};

const turnPhoneContainer: Variant = {
  display: 'flex',
  backgroundColor: 'main.1',
  padding: 3,
  borderRadius: 3,
  justifyContent: 'center',
  alignItems: 'center',
};

const mobileExpContainer: Variant = {
  height: `calc(100vh - 170px)`,
  display: 'flex',
  justifyContent: 'center',
};

const halfWidth: Variant = {
  ...formGroup,
  boxSizing: 'border-box',
  pr: [null, null, 3],
  width: [null, null, '50%'],
};

const filterLabel: Variant = {
  '> div > label': {
    color: 'heading',
    fontSize: 3,
    fontWeight: 1,
    mb: 0,
    pb: 0,
  },
};

const packageLabel: Variant = {
  '> div > label': {
    color: 'heading',
    fontSize: [3, 3, 2],
    fontWeight: [1, 1, 0],
    mb: 0,
    pb: 0,
  },
};

const contractLabel: Variant = {
  '> div > label': {
    color: 'heading',
    fontSize: 2,
    fontWeight: 0,
    mb: 0,
    pb: 0,
  },
};

const addressBirthdateDisplay: Variant = {
  '> div': {
    '> div': {
      mt: 0,
      '> div': {
        p: 0,
      },
    },
    '> h5': {
      mt: 0,
    },
  },
};

const addressBirthdateDisplayWithBorder: Variant = {
  borderBottom: '1px solid',
  borderTop: '1px solid',
  borderColor: 'second.1',
  py: 6,
  ...addressBirthdateDisplay,
};

const helpContact: Variant = {
  ...anchors.helpContact,
};

const modalCompareContainer: Variant = {
  bg: 'rgba(0,0,0,0)',
  position: 'fixed',
  height: '100%',
  right: 0,
  left: 0,
  pointerEvents: 'none',
};

const modalCompare: Variant = {
  alignItems: 'center',
  bg: 'rgba(255,255,255,0.95)',
  position: 'fixed',
  mb: ['0px', '0px', '20px'],
  width: ['100%', '100%', '85%'],
  maxWidth: ['100%', '100%', '1029px'],
  padding: [0, 6, 6],
  boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.15)',
  pointerEvents: 'all',
  borderRadius: '10px',
  bottom: 0,
  zIndex: 1,
};

const compareEmptyProduct: Variant = {
  borderStyle: 'dashed',
  borderColor: 'second.1',
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: 0,
  borderRadius: '10px',
  mr: '30px',
  mb: '10px',
  mt: '20px',
  ml: '10px',
};

const compareProduct: Variant = {
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: 0,
  borderRadius: '10px',
  ml: '10px',
  mr: '30px',
  mb: '10px',
  pb: '10px',
  mt: '20px',
  boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.15)',
};

const productWrapperCompare: Variant = {
  display: 'flex',
  flexDirection: ['column', 'column', 'row'],
  flexWrap: ['nowrap', 'nowrap', 'wrap'],
  overflowY: 'auto',
  width: '100%',
};

const widget: Variant = {
  width: '100%',
};

const internetSpeedPopupContainer: Variant = {
  width: ['100%', '100%', '360px'],
  pr: [0, 0, 6],
  backgroundColor: 'background',
  borderRadius: 2,
  display: 'flex',
  flexDirection: 'column',
  '& p': {
    ...p.baseBody,
  },
  '> span': {
    mb: [4, 4, 0],
    fontSize: 2,
    color: 'second.0',
    lineHeight: 1,
  },
};

const internetSpeedPopup: Variant = {
  display: 'flex',
  justifyContent: 'space-between',
  mb: 3,
  '& span': {
    fontWeight: 1,
  },
};

const percentageBar: Variant = {
  pb: 3,
  mb: 3,
  ...borderBottomClassic,
  '> div': {
    height: 10,
    backgroundColor: 'second.1',
    width: '100%',
    borderRadius: '28px',
  },
};

const rangeSlider: Variant = {
  position: 'relative',
  maxWidth: '240px',
  '> div': {
    '&:first-of-type': {
      width: '100%',
      backgroundColor: 'second.1',
    },
    position: 'absolute',
    height: '4px',
    borderRadius: '8px',
    backgroundColor: 'main.1',
  },
};

const pricePopupContainer: Variant = {
  width: ['100%', '100%', '360px'],
  backgroundColor: 'background',
  borderRadius: 2,
  display: 'flex',
  flexDirection: 'column',
};

const searchModal: Variant = {
  position: 'absolute',
  zIndex: 1,
  backgroundColor: 'main.0',
  width: '350px',
  marginTop: 1,
  overflowY: 'scroll',
  boxShadow: 'default',
  maxHeight: ['190px', '190px', '480px'],
  borderRadius: 2,
};

const fullWidthSearchModal: Variant = {
  ...searchModal,
  position: 'absolute',
  width: '100%',
};

const moreInfoReview: Variant = {
  ...borderBottomClassic,
  mb: 6,
  pb: 6,
};

const productRightCol: Variant = {
  '>div': {
    '&:first-of-type>div:first-of-type': {
      mr: [60, null, 4],
    },
    '&:last-of-type': {
      display: ['flex', null, 'none'],
      flexDirection: 'column',
      '>div:first-of-type': {
        mt: 3,
      },
    },
  },
};

const countdown: Variant = {
  display: 'inline-block',
  pr: 2,
  py: 1,
  pl: 6,
  borderTopRightRadius: 3,
  borderBottomRightRadius: 3,
};

const countdownReverted: Variant = {
  display: 'inline-block',
  py: 1,
  px: 2,
  borderTopLeftRadius: 3,
  borderBottomLeftRadius: 3,
};

const iconMarkerBig: Variant = {
  position: 'relative',
  alignItems: 'center',
  bg: 'second.2',
  border: '1px solid main.2',
  borderRadius: 3,
  display: 'flex',
  height: 48,
  justifyContent: 'center',
  width: 48,
  '> svg': {
    width: 24,
    height: 24,
  },
  zIndex: 1,
};

const iconMarkerSmall: Variant = {
  ...iconMarkerBig,
  width: 40,
  height: 40,
  '> svg': {
    width: 21,
    height: 21,
  },
};

const countbar: Variant = {
  display: 'flex',
  '> div': {
    display: 'flex',
    boxShadow: 'default',
    justifyContent: 'center',
    alignItems: 'center',
    width: 20,
    height: 25,
    fontWeight: 1,
    fontSize: 2,
    fontFamily: 'heading',
    borderRadius: 4,
    ':not(:last-child)': {
      marginRight: '2px',
    },
  },
};

const fullWidthOfScreen: Variant = {
  width: '100vw',
  position: 'relative',
  left: '50%',
  right: '50%',
  marginLeft: '-50vw',
  marginRight: '-50vw',
  boxSizing: 'border-box',
};

const experienceCollectiveSliderContainer: Variant = {
  ...fullWidthOfScreen,
  gap: 14,
  '& > :first-child': {
    marginLeft: 4,
  },
  '& > :last-child': {
    marginRight: 4,
  },
  '::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
  scrollSnapType: 'x mandatory',
  scrollPadding: 16,
};

const extraOptionsCheckbox: Variant = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  'div:first-child': {
    pb: 0,
    label: {
      ml: 2,
    },
  },
  '&:not(:last-child)': {
    mb: 3,
  },
};

const filterOptionsContainer: Variant = {
  ...primaryContainerWithoutPadding,
  position: ' absolute',
  top: '85px',
  minWidth: '350px',
  left: '15px',
};

const filterOptionItem = {
  cursor: 'pointer',
  padding: 3,
  '&:hover': {
    background: 'second.1',
  },
};

const customerBenefit: Variant = {
  display: 'flex',
  flexDirection: 'column',
  mb: 3,
  ml: 3,
  '& p:not(:last-child)': {
    mb: 2,
  },
};

const cashbackIcon: Variant = {
  height: 28,
  background: '#00DD83',
  borderRadius: '5px 0px 0px 5px',
};

const cashbackText: Variant = {
  background: '#00DD83',
  height: 28,
  borderRadius: '0px 5px 5px 0px',
  paddingRight: 1,
  color: 'main.2',
  cursor: 'pointer',
  fontSize: 2,
  fontWeight: 1,
};

const sliderWrapper: Variant = {
  display: 'flex',
  overflowX: 'auto',
  padding: [0, 0, '16px 20px'],

  '&::-webkit-scrollbar': {
    height: '5px',
    backgroundColor: '#d4d7dd',
  },

  '&::-webkit-scrollbar-track': {
    boxShadow: '#f1f1f1',
  },

  '&::-webkit-scrollbar-thumb': {
    background: '#888',
  },

  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
};

const topThreeOuterWrapper: Variant = {
  '@media (min-width: 767px)': {
    pb: '48px',
    boxShadow:
      '0px 4px 8px 0px rgba(62, 72, 101, 0.08), 0px 2px 8px 0px rgba(78, 90, 126, 0.08)',
    borderBottomLeftRadius: '40px',
    borderBottomRightRadius: '40px',
    background:
      'linear-gradient(0deg, #F8F8F7 0%, #F8F8F7 100%), linear-gradient(0deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0.80) 100%), linear-gradient(333deg, rgba(210, 255, 241, 0.60) 14.22%, #EBFFF1 91.57%)',
  },
};

const topThreeDesktopWrapper: Variant = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridGap: '32px',
  justifyContent: 'center',
};

const topThreeMobileWrapper: Variant = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridGap: '16px',
};

const divVariants = {
  topThreeDesktopWrapper,
  topThreeMobileWrapper,
  topThreeOuterWrapper,
  sliderWrapper,
  productRightCol,
  moreInfoReview,
  widget,
  productUsp,
  prosConsItem,
  accordionContainer,
  avatar,
  paragraphsContainer,
  priceBig,
  priceBigWithBorder,
  priceMedium,
  priceMediumWithoutBorder,
  priceCompare,
  primaryContainer,
  primaryContainerPopover,
  ratingReviews,
  footnotesContainer,
  formGroup,
  formGroupError,
  formGroupInline,
  formGroupInlineReversed,
  formGroupInlineReversedWithBorder,
  sustainability,
  prosCons,
  product,
  grayedContainer,
  grayedContainerMobile,
  productTabSwitch,
  primaryCard,
  secondaryCard,
  complementaryCard,
  filters,
  bannerInfo,
  bannerWarning,
  bannerSuggestion,
  bannerDiscount,
  bannerDiscountMobile,
  sections,
  startWidget,
  startWidgetHorizontal,
  startWidgetHorizontalPadded,
  modalContainer,
  productModalTopPanel,
  productModalProductPrice,
  tabViewTabsContainer,
  tabViewTabsContainerIndented,
  tabViewTab,
  tabViewTabSelected,
  unitInput,
  tabViewContent,
  tabViewContentIndented,
  divider,
  checkboxGroup,
  contentTypeCheckbox,
  select,
  operational,
  contactItem,
  productLogoWrapper,
  productLeftCol,
  modalAccordionContent,
  modalHeader,
  uspParagraphContainer,
  uspParagraphContainerTop,
  borderCard,
  personalDataFieldContainer,
  personalDataTemplateContainer,
  truncatedReview,
  addressInSidenav,
  sidenav,
  promotionBar,
  promotionBarItem,
  applyFormFooterContainer,
  membershipUsp,
  borderBottomClassic,
  YPaddingMedium,
  lightTabViewTabsContainer,
  lightTabViewTabsContainerForModal,
  lightTabViewTab,
  lightTabViewTabSelected,
  afterTheSwitchApply,
  circleWrapper,
  CheckoutTopNotification,
  termsListWrapper,
  tooltipContainer,
  detailsListHeading,
  unavailablePriceContainer,
  innerComparisonContainer,
  sustainabilityRegular,
  outerComparisonContainer,
  uniqueRowField,
  addressDisplay,
  headRowContainer,
  bodyRowContainer,
  cellContainer,
  accordionChild,
  accordionHeader,
  turnPhoneContainer,
  mobileExpContainer,
  halfWidth,
  filterLabel,
  addressBirthdateDisplay,
  addressBirthdateDisplayWithBorder,
  helpContact,
  modalCompareContainer,
  modalCompare,
  compareEmptyProduct,
  compareProduct,
  productWrapperCompare,
  internetSpeedPopupContainer,
  internetSpeedPopup,
  percentageBar,
  rangeSlider,
  searchModal,
  contractLabel,
  packageLabel,
  countdown,
  countdownReverted,
  iconMarkerBig,
  iconMarkerSmall,
  countbar,
  fullWidthOfScreen,
  experienceCollectiveSliderContainer,
  pricePopupContainer,
  filterOptionsContainer,
  filterOptionItem,
  extraOptionsCheckbox,
  customerBenefit,
  cashbackIcon,
  cashbackText,
  fullWidthSearchModal,
  radioTileHorizontal,
  radioTileVertical,
  labelChecked,
};

export default divVariants;
